export default {"gitHash":"9cada2426e6fc351d7093a96413ee81b58d1c9b3","gitHashShort":"9cada24","time":1649341369575,"platform":"linux","arch":"x64"};